export default "__VITE_ASSET__DkZm7mFC__"